import MDBox from "components/MDBox";
import axios from "axios";
import MDInput from "components/MDInput";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MDButton from "components/MDButton";
import { useState, useEffect } from "react";
import FormControl from "@mui/material/FormControl";
import MDBackdrop from "components/MDBackdrop";
import { useSnackbar } from "notistack";

import CloseIcon from '@mui/icons-material/Close';
import { useMaterialUIController } from "context";
import theme from "assets/theme";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import OutlinedInput from "@mui/material/OutlinedInput";
import Select from '@mui/material/Select';
import IconButton from '@mui/material/IconButton';

import Completion from "./Completion";
import '../user_service_maintenace_mgmt/Somecss.css';

import {
    isValidUsername,
    isValidEmail,
    isValidPassword,
    isValidPhone,
    allowOnlyAlphanumeric,
} from "../../utils/Constant";

function PopAddBasic(props) {
    const [isDialogOpen, setIsDialogOpen] = useState(props.isDialog);
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;
    const { sidenavColor } = controller;
    const [isDisabled, setIsDisabled] = useState(false);
    const [isBackdrop, setIsBackdrop] = useState(false);
    const { onClose } = props;

    const handleChange = (event) => {
        const { name, value } = event.target;

        setValues((prev) => ({
            ...prev,
            [name]: value,
        }));
    };


    const handleBlur = (event) => {
        const { name, value } = event.target;
        const newErrors = { ...errors };

        switch (name) {
            case "username":
                if (!allowOnlyAlphanumeric(value)) {
                    newErrors.username = "Username should contain only letters and numbers";
                } else {
                    delete newErrors.username;
                }
                break;

            case "email":
                if (!isValidEmail(value)) {
                    newErrors.email = "Email ID must be valid";
                } else {
                    delete newErrors.email;
                }
                break;

            case "password":
                if (!isValidPassword(value)) {
                    newErrors.password =
                        "Password must be at least 8 characters with 1 number and 1 special character";
                } else {
                    delete newErrors.password;
                }
                break;

            case "phone":
                if (!isValidPhone(value)) {
                    newErrors.phone =
                        "Enter a valid mobile number (05XXXXXXXX or +9715XXXXXXXX)";
                } else {
                    delete newErrors.phone;
                }
                break;

            default:
                break;
        }

        setErrors(newErrors);
    };


    const initialValues = {
        username: "",
        email: "",
        password: "",
        phone: "",
        company: "",
        department: "",
    };

    const { enqueueSnackbar } = useSnackbar();
    const [values, setValues] = useState(initialValues);


    const [errors, setErrors] = useState({});
    const reset = (event) => {
        event.preventDefault();
        setValues(initialValues);
        setErrors({});
    };
    useEffect(() => {
        if (props.value) {
            setValues({
                ...initialValues,
                ...props.value,
            });
            setErrors({});
        }
    }, [props.value]);


    const handleClose = () => {
        onClose(false);
    };

    const pop = () => {
        if (!validate()) {
            enqueueSnackbar('Please fix validation errors', { variant: 'error' });
            return;
        }

        setIsBackdrop(false);
        createUser();
    };

    const createUser = () => {
        onClose(false);
        const payload = {
            "username": values.username,
            "email": values.email,
            "password": values.password,
            "phone": {
                "prefix": "+97",
                "number": values.phone
              },
            "company": values.company,
            "department": values.department,
            "role": "Admin",
        };
        axios({
            method: "post",
            url: process.env.REACT_APP_BASEURL + "user-service-and-maintenance/register",
            data: payload,
            withCredentials: true,
        })
            .then((response) => {
                if (response.data.success === true) {
                    setIsDisabled(!isDisabled);
                } else {
                    enqueueSnackbar(response.data.message, { variant: 'error' });
                }
            })
            .catch((error) => {
                enqueueSnackbar(error.response?.data?.message, { variant: 'error' });
            });
    };

    const validate = () => {
        const newErrors = {};

        if (!allowOnlyAlphanumeric(values.username)) {
            newErrors.username = "Username should contain only letters and numbers";
        }

        if (!isValidEmail(values.email)) {
            newErrors.email = "Email ID must be valid";
        }

        if (!isValidPassword(values.password)) {
            newErrors.password =
                "Password must be at least 8 characters with 1 number and 1 special character";
        }

        if (!isValidPhone(values.phone)) {
            newErrors.phone =
                "Enter a valid mobile number (05XXXXXXXX or +9715XXXXXXXX)";
        }

        if (!values.company) {
            newErrors.company = "Company is required";
        }

        if (!values.department) {
            newErrors.department = "Department is required";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    useEffect(() => {
        setIsDialogOpen(props.isDialog);
    }, [props.isDialog]);
    return (
        <>
            <Completion
                isDialog={isDisabled}
                onClose={setIsDisabled}

            />
            <MDBackdrop isBackdrop={isBackdrop} />

            <Dialog open={isDialogOpen} onClose={handleClose} fullWidth maxWidth="md" >
                <DialogTitle style={darkMode ? { backgroundColor: "#202940", color: "#ffffff", display: "flex", alignItems: "center", justifyContent: "space-between" } : { theme, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    User Information
                    <IconButton aria-label="delete" onClick={handleClose} style={darkMode ? { color: "#ffffff" } : theme}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent style={darkMode ? { backgroundColor: "#202940", color: "#ffffff" } : theme}>
                    <MDBox pt={0} pb={0} px={3}>
                        <MDBox pt={0}>

                        </MDBox>

                        <MDBox p={1} component="form" role="form">
                            <MDBox p={1}>
                                <MDInput
                                    type="text"
                                    label="Username"
                                    value={values.username}
                                    name="username"
                                    fullWidth
                                    onChange={handleChange}
                                    error={!!errors.username}
                                    helperText={errors.username}
                                    onBlur={handleBlur}
                                    sx={{
                                        "& .MuiFormHelperText-root": {
                                            color: "error.main",
                                        },
                                        "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "error.main",
                                        },
                                    }}
                                />

                            </MDBox>
                            <MDBox p={1}>
                                <MDInput
                                    type="email"
                                    label="Email"
                                    value={values.email}
                                    name="email"
                                    fullWidth
                                    onChange={handleChange}
                                    error={!!errors.email}
                                    helperText={errors.email}
                                    onBlur={handleBlur}
                                    sx={{
                                        "& .MuiFormHelperText-root": {
                                            color: "error.main",
                                        },
                                        "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "error.main",
                                        },
                                    }}
                                />

                            </MDBox>
                            <MDBox p={1}>
                                <MDInput
                                    type="password"
                                    label="Password"
                                    value={values.password}
                                    name="password"
                                    fullWidth
                                    onChange={handleChange}
                                    error={!!errors.password}
                                    helperText={errors.password}
                                    onBlur={handleBlur}
                                    sx={{
                                        "& .MuiFormHelperText-root": {
                                            color: "error.main",
                                        },
                                        "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "error.main",
                                        },
                                    }}
                                />

                            </MDBox>
                            <MDBox p={1}>
                                <MDInput
                                    type="tel"
                                    label="Phone Number"
                                    value={values.phone}
                                    name="phone"
                                    fullWidth
                                    onChange={handleChange}
                                    error={!!errors.phone}
                                    helperText={errors.phone}
                                    onBlur={handleBlur}
                                    sx={{
                                        "& .MuiFormHelperText-root": {
                                            color: "error.main",
                                        },
                                        "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "error.main",
                                        },
                                    }}
                                />
                            </MDBox>

                            <MDBox p={1}>
                                <FormControl fullWidth>
                                    <InputLabel id="location-type-label">Company</InputLabel>
                                    <Select
                                        sx={{
                                            height: 50,
                                        }}
                                        labelId="company-label"
                                        id="company-select"
                                        value={values.company}
                                        name="company"
                                        onChange={handleChange}
                                        input={<OutlinedInput label="Company" />}
                                    >
                                        <MenuItem value="DTC">DTC</MenuItem>
                                        <MenuItem value="Presight">Presight</MenuItem>
                                        <MenuItem value="Others">Others</MenuItem>
                                    </Select>
                                </FormControl>
                            </MDBox>
                            <MDBox p={1}>
                                <FormControl fullWidth>
                                    <InputLabel id="location-type-label">Department</InputLabel>
                                    <Select
                                        sx={{
                                            height: 50,
                                        }}
                                        labelId="department-label"
                                        id="department-select"
                                        value={values.department}
                                        name="department"
                                        onChange={handleChange}
                                        input={<OutlinedInput label="Department" />}
                                    >
                                        {/* <MenuItem value="Chrgup">Chrgup</MenuItem> */}
                                        <MenuItem value="IT & Support">IT & Support</MenuItem>
                                        <MenuItem value="Human Resources">Human Resources</MenuItem>
                                        <MenuItem value="Finance & Accounting">Finance & Accounting</MenuItem>
                                        <MenuItem value="Operations">Operations</MenuItem>
                                        <MenuItem value="Sales & Marketing">Sales & Marketing</MenuItem>
                                        <MenuItem value="Product Management">Product Management</MenuItem>
                                        <MenuItem value="Engineering & Development">Engineering & Development</MenuItem>
                                        <MenuItem value="Quality Assurance">Quality Assurance</MenuItem>
                                        <MenuItem value="Legal & Compliance">Legal & Compliance</MenuItem>
                                        <MenuItem value="Procurement & Vendor Management">Procurement & Vendor Management</MenuItem>
                                        <MenuItem value="Others">Others</MenuItem>
                                    </Select>
                                </FormControl>
                            </MDBox>
                        </MDBox>
                    </MDBox>
                </DialogContent>
                <DialogActions style={darkMode ? { backgroundColor: "#202940", justifyContent: "space-evenly", color: "#ffffff" } : { theme, justifyContent: "space-evenly" }}>
                    <MDButton variant="gradient" color={sidenavColor} onClick={reset}>
                        Reset
                    </MDButton>
                    <MDButton variant="gradient" color={sidenavColor}

                        onClick={pop}
                    >
                        Submit
                    </MDButton>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default PopAddBasic;